<lib-header/>

<h2 class="title">Selecione a pesquisa</h2>

<div class="card-list">
  <div class="card-box" (click)="selectType(PollTypeEnum.Satisfaction)">
    <div class="card-box__content">
      <img src="assets/img/satisfaction.png" alt="Ícone de satisfação" class="card-box__image"/>
      <p class="card-box__title">
        <span>Pesquisa de </span>
        <span>satisfação</span>
      </p>
    </div>
    <div class="card-box__image-container">
    </div>
  </div>

  <div class="card-box card-box--last" (click)="selectType(PollTypeEnum.Reservation)">
    <div class="card-box__content">
      <img src="assets/img/reservation.png" alt="Ícone de reserva de pratos" class="card-box__image"/>
      <p class="card-box__title">
        <span>Pesquisa de</span>
        <span>reserva de pratos</span>
      </p>
    </div>
    <div class="card-box__image-container">
    </div>
  </div>
</div>
